import DefaultLayout from 'layouts/default';
import ListPage from 'pages/list';
import TreeView from 'components/tree-view';
import SwitchViewPage from 'pages/switch-view';
import SwitchEditPage from 'pages/switch-edit';
import SwitchNewPage from 'pages/switch-new';
import CasesListPage from 'pages/cases-list';
import CaseEditPage from 'pages/case-edit';
import SearchFormPage from 'pages/search-form';
import ResultListPage from 'pages/result-list';
import ProfilePage from 'pages/profile';
import SignInPage from 'pages/sign-in';
import Page404 from 'pages/404';
import store from '../store';
import ErrorExt from '../others/error-ext.js';
import Loading from './loading';
// import WikiList from 'pages/wiki-list';
// import WikiView from 'pages/wiki-view';
// import WikiEdit from 'pages/wiki-edit';
// import TreeWiki from 'components/tree-wiki';
// import MediasLazy from 'pages/medias-lazy';
// import PicEdit from 'pages/pic-edit';


const startApp = () => {
  if (process.env.PROD) {
    console.log('startApp -- PRODUCTION MODE');
  }
  if (process.env.DEV) {
    console.log('startApp -- DEVELOPMENT MODE');
  }
  return new Promise((resolve, reject) => {
    // get access_token from localStorage
    const storedToken = localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).access_token;
    if (storedToken) {
      store.dispatch('loadUserAndData', storedToken)
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      console.log('APP startApp NO USER');
      reject(new ErrorExt(
        'Только для авторизованных пользователей',
        {
          error: 'Доступ запрещен',
          statusCode: 401,
        },
      ));
    }
  });
};

const beforeWikiEnter = (to, from, next) => {
  console.log('beforeWikiEnter', store.getters.wikiEnabled, to);
  if (store.getters.wikiEnabled) {
    store.dispatch('wiki/loadWikis')
      .then(() => {
        console.log('beforeWikiEnter success');
        next();
      })
      .catch((err) => {
        console.log('beforeWikiEnter error', err.statusCode);
        store.commit('pushError', err);
        if (err.statusCode === 401) {
          next('/sign-in');
        }
      });
  } else {
    next('/list');
  }
};

export default [
  {
    path: '/',
    component: DefaultLayout,
    beforeEnter: (to, from, next) => {
      console.log('beforeEnter', to, from);
      Loading.show();
      startApp()
        .then(() => {
          console.log('beforeEnter success');
          Loading.hide();
          next();
        })
        .catch((err) => {
          console.log('beforeEnter error', err.statusCode);
          store.commit('pushError', err);
          Loading.hide();
          if (err.statusCode === 401) {
            next('/sign-in');
          } else {
            next('/sign-in?destroy=1');
          }
        });
    },
    redirect: '/list',
    children: [
      {
        path: 'list',
        components: {
          default: ListPage,
        },
        name: 'list',
        meta: {
          showLeft: false,
          menu: 'list',
        },
      }, // list
      {
        path: 'list/:id',
        components: {
          default: SwitchViewPage,
          left: TreeView,
        },
        name: 'unitView',
        meta: {
          showLeft: true,
          menu: 'list',
        },
      }, // list/:id
      {
        path: 'listedit/:id',
        components: {
          default: SwitchEditPage,
          left: TreeView,
        },
        name: 'unitEdit',
        meta: {
          showLeft: true,
          menu: 'list',
        },
      }, // listedit/:id
      {
        path: 'listnew/:type/:parent_id',
        components: {
          default: SwitchNewPage,
          left: TreeView,
        },
        name: 'unitNew',
        meta: {
          showLeft: true,
          menu: 'list',
        },
      }, // listnew/:type/:parentid
      {
        path: 'ic/:iid/:id',
        components: {
          default: SwitchViewPage,
          left: CasesListPage,
        },
        name: 'instrumentCaseView',
        meta: {
          showLeft: true,
          menu: 'cases',
          nav: true,
        },
      }, // ic/:iid/:id
      {
        path: 'icedit/:iid/:id',
        components: {
          default: CaseEditPage,
          left: CasesListPage,
        },
        name: 'instrumentCaseEdit',
        meta: {
          showLeft: true,
          menu: 'cases',
        },
      }, // icedit/:iid/:id
      {
        path: 'icnew/:iid',
        components: {
          default: CaseEditPage,
          left: CasesListPage,
        },
        name: 'caseNew',
        meta: {
          showLeft: true,
          menu: 'cases',
        },
      }, // icnew/:iid
      {
        path: 'icnew/:iid/:rid',
        components: {
          default: CaseEditPage,
          left: CasesListPage,
        },
        name: 'caseNewFromRequest',
        meta: {
          showLeft: true,
          menu: 'cases',
        },
      }, // icnew/:iid/:rid
      {
        path: 'c',
        redirect: 'c/all',
      }, // redirect c/all
      {
        path: 'c/:filter',
        components: {
          default: CasesListPage,
        },
        name: 'cases',
        meta: {
          showLeft: false,
          menu: 'cases',
        },
      }, // c/:filter
      {
        path: 'c/:filter/:id',
        components: {
          default: SwitchViewPage,
          left: CasesListPage,
        },
        name: 'caseView',
        meta: {
          showLeft: true,
          menu: 'cases',
          nav: true,
        },
      }, // c/:filter/:id
      {
        path: 'cedit/:filter/:id',
        components: {
          default: CaseEditPage,
          left: CasesListPage,
        },
        name: 'caseEdit',
        meta: {
          showLeft: true,
          menu: 'cases',
        },
      }, // cedit/:filter/:id
      {
        path: 'search',
        components: {
          default: SearchFormPage,
        },
        name: 'search',
        meta: {
          showLeft: false,
          menu: 'search',
        },
      }, // search
      {
        path: 'found',
        components: {
          default: ResultListPage,
        },
        name: 'found',
        meta: {
          showLeft: false,
          menu: 'search',
        },
      }, // found
      {
        path: 'found/:id',
        components: {
          default: SwitchViewPage,
          left: ResultListPage,
        },
        name: 'resultView',
        meta: {
          showLeft: true,
          menu: 'search',
          nav: true,
        },
      }, // found/:id
      {
        path: 'foundedit/:id',
        components: {
          default: SwitchEditPage,
          left: ResultListPage,
        },
        name: 'ResultEdit',
        meta: {
          showLeft: true,
          menu: 'search',
          nav: true,
        },
      }, // foundedit/:id
      {
        path: 'profile',
        component: ProfilePage,
        name: 'profile',
        meta: {
          showLeft: false,
          menu: 'profile',
        },
      }, // profile
      {
        path: 'wikis',
        beforeEnter: beforeWikiEnter,
        components: {
          // default: WikiList,
          default: () => import('pages/wiki-list'),
        },
        name: 'wikis',
        meta: {
          showLeft: false,
          menu: 'wiki',
        },
      }, // /wikis
      {
        path: 'wiki/:fullId',
        beforeEnter: beforeWikiEnter,
        components: {
          // default: WikiView,
          default: () => import('pages/wiki-view'),
          // left: TreeWiki,
          left: () => import('components/tree-wiki'),
        },
        name: 'wikiView',
        meta: {
          showLeft: true,
          menu: 'wiki',
        },
      }, // /wiki/:fullId
      {
        path: 'wikiedit/:fullId',
        beforeEnter: beforeWikiEnter,
        components: {
          // default: WikiEdit,
          default: () => import('pages/wiki-edit'),
          // left: TreeWiki,
          left: () => import('components/tree-wiki'),
        },
        name: 'wikiEdit',
        meta: {
          showLeft: true,
          menu: 'wiki',
        },
      }, // /wikiedit/:fullId
      {
        path: 'wikinew/:parent_id',
        beforeEnter: beforeWikiEnter,
        components: {
          // default: WikiEdit,
          default: () => import('pages/wiki-edit'),
          // left: TreeWiki,
          left: () => import('components/tree-wiki'),
        },
        name: 'wikiNew',
        meta: {
          showLeft: true,
          menu: 'wiki',
        },
      }, // wikinew/:parent_id
      {
        path: 'x',
        redirect: 'x/all',
      }, // redirect x/all
      {
        path: 'x/:filter',
        components: {
          // default: MediasLazy,
          default: () => import('pages/medias-lazy'),
        },
        name: 'medias',
        meta: {
          showLeft: false,
          menu: 'medias',
        },
      }, // medias
      /* {
        path: 'picedit/:id',
        components: {
          default: PicEdit,
        },
        name: 'picEdit',
        meta: {
          showLeft: false,
          menu: 'medias',
        },
      }, // picedit/:id */
    ],
  },

  {
    path: '/enter/:token',
    beforeEnter: (to, from, next) => {
      console.log('enterApp token', to.params.token);
      store.commit(
        'modifyUser',
        {
          email: '',
          screenname: '',
          password: '',
          access_token: to.params.token,
          db: '',
          roles: [],
          telcode: null,
        },
      );
      console.log('enterApp next list');
      next('/list');
    },
  }, // /enter

  {
    path: '/sign-in',
    component: SignInPage,
    name: 'signIn',
  }, // /sign-in

  { // Always leave this as last one
    path: '*',
    component: Page404,
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js